import "./landing/styles/landing.css"
import { renderHomePage } from "./landing/pages/HomePage"

const root = document.getElementById("app")

if (!root) {
  throw new Error("Root element #app not found")
}

async function start() {

  await renderHomePage(root)

  // отключаем восстановление позиции скролла
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual"
  }

  // принудительный скролл к якорю
  const hash = window.location.hash

  if (hash === "#pricing") {

    const el = document.getElementById("pricing")

    if (el) {

      const headerOffset = 120

      const elementPosition =
        el.getBoundingClientRect().top + window.scrollY

      const offsetPosition =
        elementPosition - headerOffset

      window.scrollTo({
        top: offsetPosition,
        behavior: "auto"
      })

    }

  }

}

start()